/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-unresolved */
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
import { TeeTimePlayerNotJoined } from "components/TeeTimePlayerNotJoined";
import { AlertProvider, ModalAlert } from "components/Common/ModalAlert";
import { TeeTimeConfirmation } from "components/TeeTimeConfirmation";
import { FinalScorecard } from "components/Scorecard/FinalScorecard";
import { EventTeeTimes } from "components/EventTeeTimes";
import { Scorecard } from "components/Scorecard";
import ShareScreen from "components/ShareScreen";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Screen404 } from "components/404";
import { Holes } from "components/Holes";
import "./App.css";
import { DogPound } from "components/DogPound/dogPound";
import { DogPoundScorecard } from "components/Scorecard/DogpoundScorecard";
import { CreateEventScreen } from "components/CreateEvent";
import { Landing } from "components/Landing";
import { TV } from "components/Scorecard/TV";
import { TVEvent } from "components/Scorecard/TVEvent";
import { useUserData } from "hooks/useUserData";
import { useAuth } from "./hooks/useAuth";

// Обертка для установки `className`
function LayoutWrapper({ children }) {
  const location = useLocation();
  const isTVRoute = location.pathname.startsWith("/tv");

  return <div className={isTVRoute ? "" : "container"}>{children}</div>;
}

// Защищенный маршрут
function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const userData = useUserData(user);

  if (!user?.uid) {
    return <TeeTimePlayerNotJoined />;
  }
  if (user.uid && !userData?.phone) {
    return <TeeTimePlayerNotJoined extendedAuth />;
  }
  if (!user?.phone) {
    return <TeeTimePlayerNotJoined extendedAuth />;
  }
  if (user?.handicap === null || userData?.handicap === null) {
    return <TeeTimePlayerNotJoined updateHDCP />;
  }

  return children;
}

function App() {
  const { user } = useAuth();

  if (user === undefined) {
    return <ActivityIndicator />;
  }

  return (
    <BrowserRouter>
      <AlertProvider>
        <ModalAlert />
        <div id="recaptcha-verifier-container" />
        <LayoutWrapper>
          <Routes>
            <Route
              path="/event/:eventId/:teeTimeId/holes"
              element={
                <ProtectedRoute>
                  <Holes />
                </ProtectedRoute>
              }
            />
            <Route
              path="/event/:eventId/:teeTimeId/:teamId/holes"
              element={
                <ProtectedRoute>
                  <Holes />
                </ProtectedRoute>
              }
            />
            <Route
              path="/event/:eventId/:teeTimeId/:teamId/holes/booking"
              element={
                <ProtectedRoute>
                  <TeeTimeConfirmation uid={user?.uid} />
                </ProtectedRoute>
              }
            />
            <Route
              path="/event/:eventId/:teeTimeId/holes/booking"
              element={
                <ProtectedRoute>
                  <TeeTimeConfirmation uid={user?.uid} />
                </ProtectedRoute>
              }
            />
            <Route path="/invitation/:eventId" element={<EventTeeTimes />} />
            <Route path="/event/:eventId" element={<EventTeeTimes />} />
            <Route
              path="/invitation/:eventId/share"
              element={<ShareScreen />}
            />
            <Route path="/event/:eventId/share" element={<ShareScreen />} />
            <Route
              path="/event/:eventId/:teeTimeId/confirmation"
              element={
                <ProtectedRoute>
                  <Holes />
                </ProtectedRoute>
              }
            />
            <Route
              path="/event/:eventId/:teeTimeId"
              element={
                <ProtectedRoute>
                  <Holes />
                </ProtectedRoute>
              }
            />
            <Route
              path="/event/:eventId/:teeTimeId/scorecard"
              element={
                <ProtectedRoute>
                  <Scorecard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/event/:eventId/:teeTimeId/:teamId/scorecard"
              element={
                <ProtectedRoute>
                  <Scorecard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/event/:eventId/finalScorecard"
              element={<FinalScorecard />}
            />
            <Route
              path="/event/:eventId/hdcp"
              element={<TeeTimePlayerNotJoined updateHDCP />}
            />
            <Route path="/landing" element={<Landing />} />
            <Route path="/dogpound" element={<DogPound />} />
            <Route
              path="/dogpound/:eventId/finalScorecard"
              element={<DogPoundScorecard />}
            />
            <Route path="/tv" element={<TVEvent />} />
            <Route path="/tv/:eventId" element={<TV />} />
            <Route
              path="/create"
              element={
                <ProtectedRoute>
                  <CreateEventScreen />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Landing />} />
          </Routes>
          <ToastContainer />
        </LayoutWrapper>
      </AlertProvider>
    </BrowserRouter>
  );
}

export default App;
